import { MonthArray } from '@modules/Models/MonthArray';

export const FetchFuturePaymentDate= (days: any, withYear?: boolean)=>
  {
    var moment = require('moment');
    var futureDate= moment(moment(new Date())).add(days, 'days').toDate();

    return `${futureDate.getDate()} ${MonthArray[futureDate.getMonth()]} ${withYear ? futureDate.getFullYear() : ''}`
  }